import React, {useMemo} from "react";
import {Modal, Table} from "antd";
import {useTranslate} from "../../../../../../../../hooks/translate.hook";
import {Price} from "../../../../../../../../models/articles/articles.prices";
import {SmartTable} from "../../../../../../../common/smart-table/smart-table";
import {columnsFactory} from "./change-history.columns";
import {SmartTableDataHandler} from "../../../../../../../common/smart-table/smart-table.data-handler";
import {ArticleData} from "../../../../../../../../models/articles/article.data";
import {articlesService} from "../../../../../../../../services/articles/articles.service";
import {PriceHistoryEntry} from "../../../../../../../../models/articles/price/history";
import {downloadBlobFile} from "../../../../../../../../utils/blob.download";

interface ChangeHistoryModalProps {
    article: ArticleData;
    price: Price;
    onClose: () => void;
}

export const ChangeHistoryModal: React.FC<ChangeHistoryModalProps> = ({article, price, onClose}) => {

    const t = useTranslate();

    const downloadSourceFile = async (e: PriceHistoryEntry) => {
        const {blob, filename} = await articlesService.getPriceHistoryFile(e.id);
        downloadBlobFile(blob, filename)
    }

    const handler = useMemo(() => new SmartTableDataHandler(r => articlesService.getPriceHistory(r, article.id, price.price.id)), []);
    const columns = columnsFactory(t, downloadSourceFile);

    return (
        <Modal
            width={"950px"}
            visible={true}
            title={price.price.name + " - " + t("PRICES.HISTORY.TITLE")}
            onCancel={() => onClose()}
            onOk={() => onClose()}
        >
            <SmartTable
                handler={handler}
                columns={columns}
            />
        </Modal>
    );
}